module.exports = __webpack_public_path__ + "img/missionstatement.c5c422c0.png";